import { render, staticRenderFns } from "./MainPic.vue?vue&type=template&id=319b9386&scoped=true&"
import script from "./MainPic.vue?vue&type=script&lang=js&"
export * from "./MainPic.vue?vue&type=script&lang=js&"
import style0 from "./MainPic.vue?vue&type=style&index=0&id=319b9386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b9386",
  null
  
)

export default component.exports